import ActiveBookingsView from './ActiveBookingsView/ActiveBookingsView';
import ProductDetailsView from './ProductDetailsView/ProductDetailsView';

export { ProductDetailsView, ActiveBookingsView };
